import React, { useEffect, useState } from "react";
import {
  API_TOKEN_NAME,
  USER_ID,
  USER_ROLE,
  USER_EMAIL,
  LOGIN_PHONE_NUMBER,
  PATIENT_NAME,
  SEARCH_SELECTED_DOC_ID,
  SEARCH_SELECTED_DOC_NAME,
  SCHEDULE_DATE,
  IMAGE_URL,
} from "../../constants";
import { scAxiosAdmin } from "../..";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { startUserSession } from "../../userSession";
import uhlcare_logo from "../../images/uhlcare-logo.webp";
import uhl_logo from "../../images/UHL (2).webp";
import medix_logo from "../../images/medix-logo.webp";
import ma_rashed_logo from "../../images/ma rashed hospital.webp";
import mainlogo from "../../images/main-logo.webp";
import { Link } from "react-router-dom";
import Loading from "../../images/Loading_icon.gif";
const FindDoctorAndDepartmentPopup = ({
  findADoctorPopupClicked,
  setFindADoctorPopupClicked,
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [searchResultsDepartments, setSearchResultsDepartments] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const [departmentId, setDepartmentId] = useState();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    selectedDepartment: "all",
    searchedText: "",
  });
  const input_field_css = {
    maxHeight: "50px",
    fontSize: "14px",
    borderColor: "#cccccc",
    borderRadius: "5px",
  };
  const alertStyle = {
    color: "red",
  };
  const inputStyles = {
    borderRadius: "10px",
    background: "#fff",
    borderRight: "solid 1px #fff",
    border: "solid 1px #6e6e6ed0",
    padding: "15px 15px",
    fontSize: "16px",
    color: "#000",
    width: "100%",
  };

  useEffect(() => {
    const getSearchDoctors = (data) => {
      setLoading(true);
      try {
        if (findADoctorPopupClicked === true) {
          const req = scAxiosAdmin
            .request("/search/find_a_doctor", {
              method: "get",
              headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
              },
              params: {
                keyword: formData.searchedText,
                deparment: formData.selectedDepartment,
              },
            })
            .then((data) => {
              if (data.status === 200) {
                setLoading(false);
                setSearchResults(data.data.doctors);
              }
            })
            .catch((e) => {
              setLoading(false);
              console.log("your log output", e);
            });
        }
      } catch (error) {
        setLoading(false);
      }
    };
    getSearchDoctors();
  }, [formData.searchedText, departmentId, findADoctorPopupClicked]);
  useEffect(() => {
    const getAllDepartments = (data) => {
      try {
        if (findADoctorPopupClicked === true) {
          const req = scAxiosAdmin
            .request("/department/getdepartments", {
              method: "get",
              headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
              },
            })
            .then((data) => {
              if (data.status === 200) {
                setAllDepartments(data.data.data);
              }
            })
            .catch((e) => {
              console.log("your log output", e);
            });
        }
      } catch (error) {}
    };
    getAllDepartments();
  }, [findADoctorPopupClicked]);
  useEffect(() => {
    setDepartmentId(formData.selectedDepartment);
  }, [formData.selectedDepartment]);

  const handleSubmit = (event, props) => {
    event.preventDefault();
  };
  // console.log("dsgdfgsdfgsd", formData);
  return (
    <div>
      <div
        class="offcanvas offcanvas-start"
        data-bs-scroll="true"
        tabindex="-1"
        id="FindADoctorCanvas"
        aria-labelledby="offcanvasWithBothOptionsLabel"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasWithBothOptionsLabel"></h5>
          <button
            type="button"
            class="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            // onClick={() => setFindADoctorPopupClicked(false)}
          ></button>
        </div>
        <div class="offcanvas-body">
          {/* <div className="row text-center" id="logos">
            <div className="col-2 ">
              <img src={"/assets/images/alarm_1.png"} alt="uhlcare-logo" />
            </div>
            <div className="col-2">
              <img src={"/assets/images/alarm_1.png"} alt="medix-logo" />
            </div>
            <div className="col-2">
              <img src={"/assets/images/alarm_1.png"} alt="uhl-logo" />
            </div>
            <div className="col-2">
              <img src={"/assets/images/alarm_1.png"} alt="medix-logo" />
            </div>

            <div className="col-2">
              <img src={"/assets/images/alarm_1.png"} alt="medix-logo" />
            </div>
          </div> */}
          <div className="left-offcanvas">
            <h4 style={{ color: "#af9763" }}>Find a Doctor Here</h4>
            <form
              onSubmit={handleSubmit}
              id="registerform"
              className="needs-validation"
              noValidate
            >
              <div className="row mb-4">
                {/* <label>Search by Specialists</label> */}
                <div className="input-group mt-2">
                  <select
                    style={inputStyles}
                    name="selectedDoc"
                    value={formData.selectedDepartment}
                    class="form-select form-select-lg custom-form-control"
                    aria-label=".form-select-lg example"
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        selectedDepartment: e.target.value,
                      })
                    }
                  >
                    <option disabled selected value={"all"}>
                      Search by Department
                    </option>
                    <option value={"all"}>All Specialist</option>
                    {allDepartments && allDepartments.length > 0
                      ? allDepartments.map((item, index) => (
                          <option value={item.id}>
                            {item && item.department_name}
                          </option>
                        ))
                      : ""}
                    {/* <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option> */}
                  </select>
                </div>
              </div>
              <div className="row">
                {/* <label>Search by Name</label> */}
                <div className="input-group mt-2">
                  <input
                    style={inputStyles}
                    type="text"
                    className="custom-form-control"
                    placeholder="Search With Doctor's Name ..."
                    name="searchTerm"
                    id="searchTerm"
                    value={formData.searchedText}
                    onChange={(e) =>
                      setFormData({ ...formData, searchedText: e.target.value })
                    }
                    required
                    autoComplete="off"
                    // style={input_field_css}
                  />
                </div>
                <span /* style={alertStyle} */>
                  {/* {this.state.errors.fullname} */}
                </span>
              </div>
              <div className="row mt-3">
                {searchResults && searchResults.length > 0 ? (
                  searchResults.map((search_doctor) => {
                    return (
                      <Link
                        style={{ textDecoration: "none" }}
                        to={`/consultant/${search_doctor.slug}`}
                      >
                        <div
                          className="col-12 sp-0-0 mb-3"
                          key={search_doctor.id}
                        >
                          <div className="doctor-list">
                            {/* <input
                            type="radio"
                            className="doctor_id"
                            name="doctor_id"
                          /> */}
                            {/* {console.log('sfdsdfsfsdf',search_doctor)} */}
                            <div className="row">
                              <div
                                className="col-3"
                                style={{ paddingLeft: "0px" }}
                              >
                                {search_doctor.doctor_profile ? (
                                  <img
                                    src={
                                      IMAGE_URL +
                                      "DoctorProfileImg/" +
                                      search_doctor.doctor_profile
                                    }
                                    alt="doctor profile"
                                  />
                                ) : (
                                  <img
                                    src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                                    alt="doc"
                                  />
                                )}
                              </div>
                              <div className="col-9 mt-2">
                                <h5>{search_doctor.doctor_name}</h5>
                                <p>
                                  {search_doctor.degree !== ""
                                    ? search_doctor.degree
                                    : "Endocrinology & Metabolism) MD (Endocrinology & Metabolism)"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    );
                  })
                ) : (
                  <div className="col-12 sp-0-0 mb-3">
                    {loading ? (
                      <img src={Loading} alt="Loading" />
                    ) : (
                      <p style={{ color: "red" }}>No results found!</p>
                    )}
                  </div>
                )}
              </div>
              {/* <div className="row mt-2">
                <div className="col-12">
                  <button
                    variant="primary"
                    type="submit"
                    className="btn-links appointment-new submit_btn"
                    id="black-btn"
                  >
                    Find Yor Doctor{" "}
                  </button>
                </div>
              </div> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindDoctorAndDepartmentPopup;



// WEBPACK FOOTER //
// ./src/component/frontend/FindDoctorAndDepartmentPopup.js